import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "src/services/auth/auth.service";
import { Role } from "src/services/user/role.enum";
import { redesignPages } from "src/services/navigation/paths.const";
import { SubscriptionStatusService } from "../subscription/subscription-status.service";

export const HasValidSubscriptionGuard = async () => {
  const authService = inject(AuthService);
  const subscriptionStatusService = inject(SubscriptionStatusService);
  const router = inject(Router);

  const currentUser = await authService.getActiveUser();

  if (!currentUser) {
    return false;
  }

  if (currentUser.role === Role.admin || currentUser.role === Role.driver) {
    return true;
  } else {
    const subscriptionStatus = await subscriptionStatusService.getSubscriptionStatus(currentUser.id);
    if (subscriptionStatus === "active" || subscriptionStatus === "paymentDue") {
      return true;
    } else {
      await router.navigate([redesignPages.choosePlan]);
      return false;
    }
  }
};
